import { defineStore } from 'pinia';
import axios from "axios";

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useJobEntryStore = defineStore('jobEntry', {
    // arrow function recommended for full type inference.
    // state can be thought of as the data() property in a component.
    state: () => ({ // data()
        // all these properties will have their type inferred automatically
        job: {
            JobNum: null,
            JobAsmbl: [],
            JobProd: {
                OrderNum: null,
                WarehouseCode: null,
                Warehouse: {
                    WarehouseCode: null,
                    Description: null,
                    Name: null,
                    Address1: null,
                    City: null,
                    State: null,
                    Zip: null,
                    Country: null,
                    SysRowID: null,
                },
                TargetJobNum: null,
                PlanUserID: null,
                PlanID: null,
                WIPToMiscShipment: null,
                RMANum: null,
                RMALine: null,
                RMAReceipt: null,
                RMADisp: null,
                DMRNum: null,
                ReceivedQty: null,
                DMRActionNum: null,
                ShippedQty: null,
                WIPQty: null,
                DemandContractNum: null,
                DemandHeadSeq: null,
                DemandDtlSeq: null,
                DemandScheduleSeq: null,
                Plant: null,
            },
            PartNum: null,
            Part: {
                PartNum: null,
                PartDescription: null,
                IUM: null,
                TrackSerialNum: null,
                PricePerCode: null,
                SysRowID: null,
            },
            RevisionNum: null,
            ProjectID: null,
            Project: {
                ProjectID: null,
                Description: null,
                Project_UD: {
                    ForeignSysRowID: null,
                    LongDesc_c: null,
                    ProdCode_c: null,
                    ProdGroup: {
                        ProdCode: null,
                        Description: null,
                        SysRowID: null,
                    }
                }
            },
            PartDescription: null,
            PlanUserID: null,
            Person: {
                PersonID: null,
                Name: null,
                EMailAddress: null,
                SysRowID: null,
            },
            ProdQty: null,
            IUM: null,
            ReqDueDate: null,
            StartDate: null,
            SchedCode: null,
            SysRowID: null,
            InCopyList: null,
            JobEngineered: null,
            JobReleased: null,
            CommentText: null,
        },
        bom: [],
        currentAssembly: null,
        currentSubAssembly: null,
        currentMaterial: null,
        currentOperation: null,
        levelOneTab: 'Job',
        levelTwoTab: null,
        levelThreeTab: null,
        overlay: false,
        newJobModal: false,
        errorMessage: '',
        errorBool: false,
        temporaryMessage: '',
        temporaryBool: false,
        selectedParts: [],
        selectedOperations: [],
        vendors: [],
        toDeleteDetails: {}
    }),
    getters: { // computed
        currentAssemblySubAssemblies: (state) => {
            return state?.currentAssembly?.aSubAssemblies ?? []
        },
        currentAssemblyMaterials: (state) => {
            return state?.currentAssembly?.aMaterials ?? []
        },
        currentAssemblyOperations: (state) => {
            return state?.currentAssembly?.aOperations ?? []
        },
        currentAssemblyParent: (state) => {
            return state?.currentAssembly?.aParentAssembly ?? {}
        },
        relatedOperationByOpr: ( state) => (AsmSeq, OprSeq) => {
            return state?.job?.jobOpr?.find((aOperation) => aOperation.AssemblySeq === AsmSeq && aOperation.OprSeq === OprSeq)
        },
        relatedOperationByMtl: ( state) => (MtlSeq) => {
            return state?.currentAssemblyOperations?.find((aOperation) => aOperation.MtlSeq === MtlSeq)
        },
        allOperations: (state) => {
            return state?.job?.jobOpr ?? []
        },
    },
    actions: { // methods
        setErrorMessage(message){
            alert(message)
            this.overlay = false;
            // this.errorMessage = message;
            // this.errorBool = true;
        },
        setTemporaryMessage(message){
            this.temporaryMessage = message;
            this.temporaryBool = true;
            this.overlay = false;
        },
        clearErrors(){
            this.errorBool = false;
            this.errorMessage = "";
        },
        // clearTemporaryMessage(){
        //     this.temporaryBool = false;
        //     this.temporaryMessage = "";
        // },
        setJob(jobData) {
            this.job = jobData.jobDetails
            this.bom = [jobData.bomTree]
            this.vendors = jobData.vendors

            this.levelOneTab = 'Job'

            //set initial Assembly
            this.initCurrentAssembly()
        },
        initCurrentAssembly(AsmSeq = '0') {
            //set Assembly
            this.currentAssembly = this.job?.JobAsmbl?.find((assembly) => assembly.AssemblySeq === AsmSeq) ?? {}
            this.initSetCurrentAssemblySubs()
            this.overlay = false;
        },
        initSetCurrentAssemblySubs() {
            //set SubAssembly
            this.currentSubAssembly = this.currentAssemblySubAssemblies.length ? this.currentAssemblySubAssemblies[0] : null
            //set initial Material
            this.currentMaterial = this.currentAssemblyMaterials.length ? this.currentAssemblyMaterials[0] : null
            // //set initial Operation
            this.currentOperation = this.currentAssemblyOperations.length ? this.currentAssemblyOperations[0] : null
        },
        setCurrentSubAssembly(AsmSeq) {
            this.currentSubAssembly = this.currentAssemblySubAssemblies.find((assembly) => {
                return Number(assembly.AssemblySeq) == Number(AsmSeq)
            })
        },
        setCurrentMaterial(MtlSeq) {
            this.currentMaterial = this.currentAssemblyMaterials.find((material) => {
                return Number(material.MtlSeq) == Number(MtlSeq)
            })
        },
        setCurrentOperation(OprSeq) {
            this.currentOperation = this.currentAssemblyOperations.find((operation) => {
                return Number(operation.OprSeq) == Number(OprSeq)
            })
        },
        setCurrentAssemblyMaterials(job, updatingBool = false) {
            this.currentAssembly = job?.jobDetails?.JobAsmbl?.find((assembly) => assembly.AssemblySeq === this.currentAssembly.AssemblySeq) ?? {}
            if (updatingBool) {
                this.job.JobAsmbl = job?.jobDetails?.JobAsmbl;
                this.job.jobMtl = job?.jobDetails?.jobMtl;
                this.job.jobOpr = job?.jobDetails?.jobOpr;
            }

            if (!updatingBool) {
                this.initSetCurrentAssemblySubs();
            }
        },
        async refreshAssemblies(type) {
            let JobNum = this.job.JobNum;
            let job = await this.fetchJobData(JobNum);
            let material = null;
            let operation = null;
            let subAssembly = null;
            let assembly = this.currentAssembly;
            if (type === 'material') {
                material = this.currentMaterial;
            } else if (type === 'operation') {
                operation = this.currentOperation;
            } else if (type === 'subassembly') {
                subAssembly = this.currentSubAssembly;
            }
            // console.log(this.currentAssemblyParent, this.job?.JobAsmbl)
            this.setJob(job)

            if (type === 'material') {
                this.levelOneTab = 'Job Details';
                this.currentAssembly = assembly;
                this.setCurrentAssemblyMaterials(job, true);

                this.currentMaterial = this.currentAssemblyMaterials.find((mtl) => {
                    return mtl.MtlSeq === material.MtlSeq || mtl.PartNum === material.PartNum
                })

            } else if (type === 'operation') {
                this.currentAssembly = assembly;
                this.setCurrentAssemblyMaterials(job, true);

                this.levelOneTab = 'Job Details';
                this.levelTwoTab = 'Operations';
                this.currentOperation = this.currentAssemblyOperations.find((opr) => {
                    return opr.OprSeq === operation.OprSeq || opr.OpCode === operation.OpCode
                })

            } else if (type === 'assembly') {
                this.levelOneTab = 'Job Details';
                this.levelTwoTab = 'Assemblies';
                this.currentAssembly = this.job?.JobAsmbl?.find((assmbl) => {
                    return assmbl.id === assembly.id
                })
                // this.currentAssemblyParent = this.job?.JobAsmbl?.find((assmbl) => {
                //     return assmbl.id === this.currentAssemblyParent.id
                // })

            } else if (type === 'subassembly') {
                this.levelOneTab = 'Job Details';
                this.levelTwoTab = 'Assemblies';
                this.levelThreeTab = 'Subassemblies';
                this.currentAssembly = this.job?.JobAsmbl?.find((assmbl) => {
                    return assmbl.AssemblySeq === assembly.AssemblySeq
                })
                // this.currentAssemblyParent = this.job?.JobAsmbl?.find((assmbl) => {
                //     return assmbl.AssemblySeq === this.currentAssemblyParent.AssemblySeq
                // })
                this.currentSubAssembly = this.job?.JobAsmbl?.find((assmbl) => {
                    return assmbl.AssemblySeq === subAssembly.AssemblySeq
                })
            }

            this.overlay = false;
        },
        async fetchJobData(JobNum) {
            let job = null;
            const params = {
                JobNum: JobNum,
                with: [ 'project.project_ud.prodGroup', 'jobProd', 'person', 'part', 'jobAsmbl' ]
            }

            await axios.get(route('api.epicor.job-entry.job'), {params: params})
                .then((response) => {
                    // HANDLE SUCCESS
                    job = response.data.data;
                })
                .catch((err) => {
                    // HANDLE ERRORS
                    this.setErrorMessage("Cant find Job based on JobNum, call IT")
                })

            return job;
        },
        clearJob() {
            this.job = {
                JobNum: null,
                JobAsmbl: [],
                JobProd: {
                    OrderNum: null,
                    WarehouseCode: null,
                    Warehouse: {
                        WarehouseCode: null,
                        Description: null,
                        Name: null,
                        Address1: null,
                        City: null,
                        State: null,
                        Zip: null,
                        Country: null,
                        SysRowID: null,
                    },
                    TargetJobNum: null,
                    PlanUserID: null,
                    PlanID: null,
                    WIPToMiscShipment: null,
                    RMANum: null,
                    RMALine: null,
                    RMAReceipt: null,
                    RMADisp: null,
                    DMRNum: null,
                    ReceivedQty: null,
                    DMRActionNum: null,
                    ShippedQty: null,
                    WIPQty: null,
                    DemandContractNum: null,
                    DemandHeadSeq: null,
                    DemandDtlSeq: null,
                    DemandScheduleSeq: null,
                    Plant: null,
                },
                PartNum: null,
                Part: {
                    PartNum: null,
                    PartDescription: null,
                    IUM: null,
                    TrackSerialNum: null,
                    PricePerCode: null,
                    SysRowID: null,
                },
                RevisionNum: null,
                ProjectID: null,
                Project: {
                    ProjectID: null,
                    Description: null,
                    Project_UD: {
                        ForeignSysRowID: null,
                        LongDesc_c: null,
                        ProdCode_c: null,
                        ProdGroup: {
                            ProdCode: null,
                            Description: null,
                            SysRowID: null,
                        }
                    }
                },
                PartDescription: null,
                PlanUserID: null,
                Person: {
                    PersonID: null,
                    Name: null,
                    EMailAddress: null,
                    SysRowID: null,
                },
                ProdQty: null,
                IUM: null,
                ReqDueDate: null,
                StartDate: null,
                SchedCode: null,
                InCopyList: null,
                JobEngineered: null,
                JobReleased: null,
                CommentText: null,
            };
            this.bom = [];
            this.currentAssembly = null;
            this.currentSubAssembly = null;
            this.currentMaterial = null;
            this.currentOperation = null;
            this.levelOneTab = 'Job';
            this.levelTwoTab = null;
            this.levelThreeTab = null;
            this.newJobModal = false;
            this.newJobNumUpdated = null;
        }
    },
})
